import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export const EditingContext = createContext(null);
export const EditingProvider = ({ children, isEditing }) => {
    return (_jsx(EditingContext.Provider, { value: { isEditing }, children: children }));
};
export const useEditingContext = () => {
    const context = useContext(EditingContext);
    if (!context)
        throw new Error('useEditingContext must be used within a EditingProvider');
    return context;
};
